<div class="table-responsive" [class.overflow-hidden]="keyLogService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
            <tr [ngClass]="{'noSort': keyLogService.data.allKeyLogs.data.length < 2}">
                <th></th>
                <th (click)="orderBy('keyTag', $event)" class="footable-sorted">
                    Key Tag <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="keyLogService.buildings.length > 1" (click)="orderBy('building.name', $event)">
                    Building<span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('suite.suiteNumber', $event)">
                    Unit/Room <span class="footable-sort-indicator"></span>
                </th>
                <th>Purpose</th>
                <th>Notes</th>
                <th (click)="orderBy('status', $event)">Status<span class="footable-sort-indicator"></span></th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="keyLogService.data.allKeyLogs.data" let-index="index">
                <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="keyLogService.toggleDetailedView(item)">
                    <td>
                        <label class="img-checkbox">
                            <input type="checkbox" [ngModel]="item.checked">
                            <label><svg-checked></svg-checked></label>
                        </label>
                    </td>
                    <td>{{item.keyTag}}</td>
                    <td *ngIf="keyLogService.buildings.length > 1">{{item.buildingName}}</td>
                    <td>{{item.suiteNumber}}</td>
                    <td>{{item.purpose}}</td>
                    <td>{{item.notes}}</td>
                    <td>
                        <span *ngIf="item.status === 'available'"  class="text-uppercase label label-picked_up">
                            Available
                        </span>
                        <span *ngIf="item.status === 'signet_out'"  class="text-uppercase label label-received">
                            Signed Out
                        </span>
                    </td>
                    <td class="td-action-btn">
                        <div *ngIf="item.isCanEdit" class="input-group-btn btn-in-table input-group">
                            <button (click)="signOutKey(item)"
                                    *ngIf="item.status === 'available'"
                                    class="btn btn-white btn-xs sign-out-return-buttons">
                                Sign Out Key
                            </button>
                            <button (click)="returnKey(item)"
                                    *ngIf="item.status === 'signet_out'"
                                    class="btn btn-white btn-xs sign-out-return-buttons">
                                Return Key
                            </button>
                        </div>
                        <div *ngIf="!item.isCanEdit" class="input-group-btn btn-in-table input-group">
                            <button (click)="getHistory(item)" class="btn btn-white btn-xs sign-out-return-buttons">
                                History
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of keyLogService.emptyRowService.emptyRow" style="cursor: default;">
                <td></td><td>&nbsp;</td><td *ngIf="keyLogService.buildings.length > 1"></td>
                <td></td><td></td><td></td><td></td><td></td>
            </tr>
        </tbody>
    </table>

    <empty-result-message [isEmpty]="!keyLogService.data.allKeyLogs.total"
                          [isServiceUnavailable]="keyLogService.showServiceUnavailable"
                          [isLoading]="keyLogService.spinnerShow">
        You have no keys listed on the system<br>
        <span *ngIf="keyLogService.canEdit()">
            <a href="javascript://" (click)="keyLogService.isKeyLogModalShow = true" class="mtv-primary-color clickable-text">add a key</a> now
        </span>
    </empty-result-message>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log-list/key-log-list.component.html